<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Under Graduate Programs</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">Under Graduate Programs</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="program-container">
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/it.webp" alt="B.Sc in (AI-ML) | GHRCACS, PUNE"
                            class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class="text-black">B.Sc <br> (AI-ML)</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a routerLink="/" class="cmn-white-button">Learn
                                More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-B-administration.webp"
                            alt="Bachelor of Business Administration | GHRCACS, PUNE" class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class=" text-black">Bachelor of Business Administration</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a
                                routerLink="/ug-bachelor-of-business-administration" class="cmn-white-button">Learn
                                More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-computer.webp"
                            alt="B.Sc. Computer Science | GHRCACS, PUNE" class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class=" text-black"> B.Sc. Computer <br> Science</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a
                                routerLink="/ug-bachelor-of-science-computer-sciencen" class="cmn-white-button">Learn
                                More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-B-management.webp"
                            alt="BBA(Computer Application) | GHRCACS, PUNE" class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class=" text-black">BBA(Computer Application)</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a
                                routerLink="/ug-bachelor-of-business-administration-computer-application"
                                class="cmn-white-button">Learn
                                More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-commerce.webp"
                            alt="Bachelor of Commerce | GHRCACS, PUNE" class="w-100" />

                    </div>
                    <div class="program-details">
                        <div class="d-flex  justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class=" text-black"> Bachelor of Commerce</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a routerLink="/ug-bachelor-of-commerce"
                                class="cmn-white-button">Learn More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/it.webp"
                            alt="B.Sc(Information Technology) | GHRCACS, PUNE" class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class="text-black"> B.Sc(Information Technology)</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a routerLink="/bsc-Information-technology"
                                class="cmn-white-button">Learn More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/data.webp"
                            alt="BBA(International Business) | GHRCACS, PUNE" class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class=" text-black">BBA(International Business)</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a routerLink="/bba-international-business"
                                class="cmn-white-button">Learn More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="program-card">
                    <div class="program-img">
                        <img loading="lazy" src="{{baseUrl1}}/courses/master-of-commerce.webp"
                            alt="BCA (Science) | GHRCACS, PUNE" class="w-100" />
                    </div>
                    <div class="program-details">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="sec-thirdtitle w-75 text-start">
                                <h5 class=" text-black">BCA <br> (Science)</h5>
                            </div>
                            <div class="share-img w-auto text-end">
                                <a href="#"><img loading="lazy"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                                        alt="GHRCACS, PUNE" class="img-fluid"></a>
                            </div>
                        </div>
                        <div
                            class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
                            <div>
                                <i class="fa fa-calendar-o"></i>
                                <span>3 Years</span>
                            </div>
                            <div>
                                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                                <span>Full Time</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"><a routerLink="/bsc-computer-aplication"
                                class="cmn-white-button">Learn More</a>
                            <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply
                                Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>